// extracted by mini-css-extract-plugin
module.exports = {"container":"zD7Pv","show":"wIGpR","text":"oHfCi","header":"OR046"};